import PropTypes from 'prop-types'

export const DEFAULT_ERROR_TITLE = 'Error'

export const NOTIFICATION_ROLES = {
  INFO: 'info',
  CAUTION: 'caution',
  ERROR: 'error',
  SUCCESS: 'success',
} as const

export const DEFAULT_NOTIFICATION_OPTIONS = Object.freeze({
  title: '',
  message: '',
  role: NOTIFICATION_ROLES.INFO,
  showIcon: true,
  iconName: '',
  duration: 5000,
  autoDismiss: true,
  dismissible: true,
})

export const DISMISSIBLE_DURATION_THRESHOLD = 5000 // if more than 5 seconds, force dismissible

/**
 * This is a mediocre excuse for an interface, but all notifications should be an object with at least these two keys
 * present
 *
 * TODO: ditch this once we don't need it anymore
 */
export const NotificationPropTypes = PropTypes.shape({
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
})

export const NotifierPropTypes = PropTypes.shape({
  info: PropTypes.func.isRequired,
  success: PropTypes.func.isRequired,
  warn: PropTypes.func.isRequired,
  error: PropTypes.func.isRequired,
  close: PropTypes.func,
})
